import React from 'react';
import { Modal, ModalTitle, ModalContent, ModalActions, Button } from '@deere/fuel-react'

//To be used as the base for Modals, contains the buttons for submit and cancel, the content is passed as children
export const MultiUseModal = ({
                                isOpen,
                                modalTitle,
                                onSubmit,
                                handleModalClose,
                                children,
                                hideActions
                           }) => {

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Modal
                    id={'announcement-modal'}
                    aria-describedby="alert-Modal-description"
                    aria-labelledby="alert-Modal-title"
                    onClose={handleModalClose}
                    open={isOpen}>
                    <ModalTitle id="alert-Modal-title">{modalTitle}</ModalTitle>
                    <ModalContent>
                        {children}
                    </ModalContent>
                    {!hideActions &&
                        <ModalActions>
                            <Button
                                onClick={handleModalClose}
                                variant="secondary">
                                {'Cancel'}
                            </Button>
                            <Button
                                onClick={onSubmit}
                                variant="primary">
                                {'Submit'}
                            </Button>
                        </ModalActions>
                    }
                </Modal>
        </div>
    );
};
